interface FloatingButtonsProps {
    items: Array<React.ReactNode>
}

export const FloatingButtonsMenu: React.FunctionComponent<FloatingButtonsProps> = ({items}) => {
    return (
        <div 
            style={{
                position: "fixed",
                bottom: "13%",
                right: "3%",
                transformOrigin: "center bottom",
                zIndex: "10",
                display:"flex", 
                justifyContent: "flex-end",
                flexDirection: "column",
                pointerEvents: "none"
            }}
        >
            {items.map((item, i) => (
                <div key={i}>
                    <div style={{marginTop: "30px"}}/>
                    <div style={{marginLeft: "auto", pointerEvents: "auto"}}>{item}</div>
                </div>
            ))}
        </div>
    );
}